"use client";

import { useState } from "react";

const FB_PATH =
  "M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z";

export default function BonusClaimButton({
  claimUrl,
  stale,
  pluralName,
}: {
  claimUrl?: string;
  stale: boolean;
  pluralName: string;
}) {
  const [claimed, setClaimed] = useState(false);

  function handleClaim() {
    if (claimed) return;
    setClaimed(true);
  }

  if (claimUrl && !claimed) {
    return (
      <a
        href={claimUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClaim}
        style={{
          borderRadius: 12,
          padding: "11px 20px",
          background: stale ? "#64748b" : "#1877F2",
          fontSize: 15,
          textDecoration: "none",
        }}
        className="mt-auto flex w-full items-center justify-center gap-2.5 font-bold text-white"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" aria-hidden>
          <path d={FB_PATH} />
        </svg>
        {stale ? "Try this link" : `Claim ${pluralName}`}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClaim}
      disabled={claimed}
      style={{
        borderRadius: 12,
        padding: "11px 20px",
        background: claimed ? "#16a34a" : "#1877F2",
        transition: "background 0.2s",
        fontSize: 15,
        opacity: claimed ? 0.85 : 1,
      }}
      className="mt-auto flex w-full items-center justify-center gap-2.5 font-bold text-white"
    >
      {claimed ? (
        <>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Opened
        </>
      ) : (
        <>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="white" aria-hidden>
            <path d={FB_PATH} />
          </svg>
          Claim {pluralName}
        </>
      )}
    </button>
  );
}
